module.exports = __webpack_public_path__ + "static/img/yanjingyuan.cb9cf8e6.png";